import { render } from "./DynamicTable.vue?vue&type=template&id=1e73a71e&scoped=true&ts=true"
import script from "./DynamicTable.ts?vue&type=script&lang=ts"
export * from "./DynamicTable.ts?vue&type=script&lang=ts"

import "./DynamicTable.vue?vue&type=style&index=0&id=1e73a71e&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e73a71e"]])

export default __exports__